module.exports = __webpack_public_path__ + "static/media/BackgroundBadOptimized.35a5a8d4.jp2";